// frontend/src/features/workflows/components/Popover.jsx
import React from 'react';

export function Popover({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
      {/* semi-transparent backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />

      {/* panel */}
      <div
        className="
          relative z-50
          bg-white rounded-lg shadow-xl
          p-8
          max-w-2xl w-full        /* ← was max-w-md, now max-w-2xl */
          animate-slideDown
          overflow-visible        /* ← allow child dropdowns to overflow */
        "
      >
        {children}
      </div>
    </div>
  );
}
